import React from "react";
import { motion } from "framer-motion";
import { useQuotePopup } from "../context/QuotePopupContext";

const DRY_IMG_1 =
  "https://images.pexels.com/photos/37180553/pexels-photo-37180553.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const DRY_IMG_2 =
  "https://images.pexels.com/photos/30510828/pexels-photo-30510828.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const ITEMS = [
  { name: "Almonds", desc: "California & Mamra grade — bulk packs.", origin: "USA · Iran" },
  { name: "Cashews", desc: "W180 / W240 / W320 whole kernels.", origin: "Mangalore · Goa" },
  { name: "Pistachios", desc: "Salted, plain & in-shell varieties.", origin: "Iran · USA" },
  { name: "Raisins", desc: "Green, golden & black seedless.", origin: "Nashik · Afghanistan" },
  { name: "Dates", desc: "Medjool, Ajwa, Kimia premium grades.", origin: "Saudi · Iran" },
];

export const DryFruits = () => {
  const { openPopup } = useQuotePopup();
  return (
    <section
      id="dryfruits"
      data-testid="dryfruits-section"
      className="section-pad bg-white"
    >
      <div className="container-luxury">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >
              <div className="heading-eyebrow">
                <span className="line" />
                <span className="text">Beyond Cardamom</span>
              </div>
              <h2 className="font-serif text-3xl md:text-5xl text-[#0E4D3D] leading-tight">
                Premium dry fruits, sourced to the same standard.
              </h2>
              <p className="mt-5 text-[#4A4A4A] text-base md:text-lg font-light leading-relaxed">
                Our secondary trade vertical — for clients who prefer a single,
                trustworthy supplier across spices and nuts. Origin-tracked,
                bulk-ready, wholesale-priced.
              </p>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-2">
                {ITEMS.map((it, i) => (
                  <motion.div
                    key={it.name}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.05, duration: 0.5 }}
                    className="border border-[#0E4D3D]/15 px-4 py-3 hover:border-[#C9A227] hover:bg-[#FAF8F2] transition-colors"
                    data-testid={`dryfruit-${i}`}
                  >
                    <div className="font-serif text-[#0E4D3D] text-base">
                      {it.name}
                    </div>
                    <div className="label-overline text-[#C9A227] mt-1 text-[0.6rem]">
                      {it.origin}
                    </div>
                  </motion.div>
                ))}
              </div>

              <button
                onClick={openPopup}
                data-testid="dryfruits-cta"
                className="btn-emerald mt-8"
              >
                Enquire For Dry Fruits
              </button>
            </motion.div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="grid grid-cols-2 gap-4">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="aspect-[3/4] overflow-hidden group"
              >
                <img
                  src={DRY_IMG_1}
                  alt="Premium dry fruits mix"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]"
                />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15, duration: 0.8 }}
                className="aspect-[3/4] overflow-hidden mt-12 group"
              >
                <img
                  src={DRY_IMG_2}
                  alt="Dry fruit jar"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
